<template>
  <div class="customer">
    <v-row no-gutters v-if="fieldsLoading">
      <v-col v-for="n in 9" :key="n" cols="12" sm="6" lg="3">
       <v-sheet class="mt-2">
        <v-skeleton-loader class="mx-auto" type="list-item"></v-skeleton-loader>
      </v-sheet>
      </v-col>
    </v-row>
    <form-data v-else :references.sync="formReferences" :model="modelObj" ref="crmReference">
      <template slot="combo">
        <v-combobox :label="$t('message.customer.name')" hide-details outlined dense v-model="modelObj.name" :rules="$_requiredValidation" :loading="isLoading"
          :search-input.sync="search" :items="companyArray" item-text='navn'
          :disabled="!!modelObj.external_id">
        </v-combobox>
        <small v-if="isCustomerExists" class="error--text">{{ $t('message.customer.exists') }}</small>
      </template>
      <template slot="extraDetails" v-if="modelObj.id">
        <label class="pa-2" v-if="modelObj.sharepoint_link">{{ $t('message.onedriveSettings.odLink') }}: <a  target="_blank" :href="modelObj.sharepoint_link">{{ modelObj.sharepoint_link }}</a></label>
        <div class="pa-2">
          <v-expansion-panels class="pa-0 pb-2">
            <attachments :model="modelObj" :module="SP_CUSTOMER"></attachments>
          </v-expansion-panels>
          <!-- List of contacts -->
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header class="expansion--panel">
                <template v-slot:default="{ open }">
                  <v-row no-gutters>
                    <v-col cols="4">{{ $t('message.customer.contacts') }}</v-col>
                    <v-col cols="8" class="text-right pr-6">
                      <v-fade-transition leave-absolute>
                        <span v-if="!open" key="0">{{ $t('message.common.total') }}: {{ totalContactCount }}</span>
                      </v-fade-transition>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-2">
                <v-form ref="contactsForm">
                  <v-container class="pa-0">
                    <v-row>
                      <v-col cols="12" md="6" lg="6">
                        <v-btn color="primary" class="mt-1" @click="addNewContact">{{ $t('message.common.addNew') }}</v-btn>
                      </v-col>
                      <v-col class="d-flex" cols="12" sm="6" lg="3" md="4">
                        <v-select :items="activeTypes" dense v-model="activeOrInactive" outlined item-text="text" item-value="id" :label="$t('message.customer.activeOrInactive')" hide-details></v-select>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
                <v-progress-linear v-if="loadingContacts" indeterminate color="primary"></v-progress-linear>
                <template v-if="listOfContacts && listOfContacts.length > 0">
                  <v-container class="pa-0">
                    <v-row>
                      <v-col cols="6" lg="3" md="4" v-for="(contact) in listOfContacts" :key="contact.id" class="mt-1">
                        <v-hover v-slot:default="{ hover }">
                          <v-card class="mt-1 elevation-3 participants" :elevation="hover ? 14 : 5">
                            <v-list-item class="pa-1">
                              <v-avatar color="primary">
                                <span class="mx-auto white--text">
                                  <b>{{ setAvatarName(contact) }}</b>
                                </span>
                              </v-avatar>
                              <v-divider class="ma-0 ml-1" vertical></v-divider>
                              <v-list-item-content class="pa-1 ma-0">
                                <v-list-item-title class="subtitle-1">{{ contact.firstname || '' }} {{ contact.lastname || '' }}</v-list-item-title>
                                <v-list-item-subtitle>
                                  {{ $t('message.customer.email') }}:
                                  <a :href="`mailto:${contact.email}`">{{ contact.email }}</a>
                                </v-list-item-subtitle>
                                <!-- <v-list-item-subtitle>{{ $t('message.user.mobile') }}: {{ contact.mobilephone || contact.telephone }}</v-list-item-subtitle> -->
                                <v-list-item-subtitle>{{ $t('message.common.note') }}: {{ contact.note }}</v-list-item-subtitle>
                              </v-list-item-content>
                              <v-divider class="ma-0 ml-1" vertical></v-divider>
                              <v-list-item-action class="pa-0 ma-0">
                                <v-btn icon color="success" @click="editContactHandler(contact.id)">
                                  <v-icon>colorize</v-icon>
                                </v-btn>
                                <v-btn icon color="error" @click="deleteContactHandler(contact.id)">
                                  <v-icon>delete_outline</v-icon>
                                </v-btn>
                              </v-list-item-action>
                            </v-list-item>
                          </v-card>
                        </v-hover>
                      </v-col>
                    </v-row>
                    <div class="text-center">
                      <v-pagination v-model="contactActivePage" :length="contactLength" circle></v-pagination>
                    </div>
                  </v-container>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- List of address -->
          <v-expansion-panels class="mt-2">
            <v-expansion-panel>
              <v-expansion-panel-header class="expansion--panel">
                <template v-slot:default="{ open }">
                  <v-row no-gutters>
                    <v-col cols="4">{{ $t('message.customer.address') }}</v-col>
                    <v-col cols="8" class="text-right pr-6">
                      <v-fade-transition leave-absolute>
                        <span v-if="!open" key="0">{{ $t('message.common.total') }}: {{ listOfAddress.length }}</span>
                      </v-fade-transition>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-2">
                <v-form ref="contactsForm">
                  <v-container class="pa-0">
                    <v-row>
                      <v-col cols="12" md="2" lg="2">
                        <v-btn color="primary" class="mt-0 mb-2" @click="addNewAddress">{{ $t('message.common.addNew') }}</v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
                <template v-if="listOfAddress && listOfAddress.length > 0">
                  <v-container class="pa-0">
                    <v-simple-table dense class="elevation-1 bordered--table">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left" v-for="(head, index) in addressHeaders" :key="index">
                              {{ head.text }}
                            </th>
                            <th>{{ $t('message.mailConfiguration.action') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item in listOfAddress" :key="item.id">
                            <td>{{ getCombinedAddress(item) }}</td>
                            <td>{{ item.countryname }}</td>
                            <td>{{ getaddressType(item.type) }}</td>
                            <!-- <td>{{ getCoordinates(item) }}</td> -->
                            <td>
                              <v-icon class="font--style"> {{ item.isstandard ? 'done' : 'clear' }} </v-icon>
                            </td>
                            <td>
                              <v-btn icon color="success" @click="editAddressHandler(item.id)">
                                <v-icon>colorize</v-icon>
                              </v-btn>
                              <v-btn icon color="error" @click="deleteAddressHandler(item.id)">
                                <v-icon>delete_outline</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-container>
                </template>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- List of Orders -->
          <v-expansion-panels class="mt-2"><!-- v-if="modelObj.issupplier" -->
            <v-expansion-panel>
              <v-expansion-panel-header class="expansion--panel">
                <template v-slot:default="{ open }">
                  <v-row no-gutters>
                    <v-col cols="4">{{ $t('message.dashboard.orders') }}</v-col>
                    <v-col cols="8" class="text-right pr-6">
                      <v-fade-transition leave-absolute>
                        <span v-if="!open" key="0">{{ $t('message.common.total') }}: {{ listOfRelatedOrders.length }}</span>
                      </v-fade-transition>
                    </v-col>
                  </v-row>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-2">
                <template v-if="listOfRelatedOrders && listOfRelatedOrders.length > 0">
                  <v-form ref="orderForm">
                    <v-container fluid class="pa-0">
                      <v-btn color="primary" :to="`/orders?customer=${modelObj.id}`">{{ $t('message.warehouse.order') }}</v-btn>
                      <v-simple-table dense class="elevation-1 bordered--table mt-3">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th width="20%">{{ $t('message.product.number') }}</th>
                              <th width="15%">{{ $t('message.tickets.status') }}</th>
                              <th width="25%">{{ $t('message.deviations.responsible') }}</th>
                              <th width="15%">{{ $t('message.layout.order') }}</th>
                              <th width="15%">{{ $t('message.customer.delivery') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="item in listOfRelatedOrders" :key="item.id">
                              <td>
                                <router-link :to="`/orders/actions/${item.id}`">{{ item.number }}</router-link>
                              </td>
                              <td>{{ item.state }}</td>
                              <td>{{ item.user_name }}</td>
                              <td>{{ item.orderdate | dateFormat }}</td>
                              <td>{{ item.deliverydate | dateFormat }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-container>
                  </v-form>
                </template>
                <v-alert prominent text v-else type="info" class="mt-2" >
                  <v-row align="center">
                    <v-col class="grow">{{ $t('message.customer.noOrdersFound') }}</v-col>
                  </v-row>
                </v-alert>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <!-- List of Products from sales order -->
          <v-expansion-panels class="mt-2">
            <v-expansion-panel>
              <v-expansion-panel-header class="expansion--panel">
                <template>
                  <v-row no-gutters>
                    <v-col cols="4">{{ $t('message.layout.products') }}</v-col>
                  </v-row>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="pt-2">
                <products></products>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </template>
      <template slot="share_report">
        <v-btn color="info" class="ml-3" @click="exportPriceList" :loading="exporting" v-if="modelObj.id" dark>
          {{ $t('message.customer.priceList') }}
        </v-btn>
      </template>
    </form-data>
    <v-dialog v-model="contactDialog" width="800" persistent>
      <form-data :references.sync="contactReference" :model="contactModel" ref="contactReference"></form-data>
    </v-dialog>
    <v-dialog v-model="addressDialog" width="800" persistent>
      <form-data :references.sync="addressReference" :model="addressModel" ref="addressReference"></form-data>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormTemplate from '@/components/FormTemplate'
import Customer from '../../mixins/Customer/index'
import axios from 'axios'
export default {
  data () {
    return {
      modelObj: {
        id: this.$route.params.crm_id,
        isactive: true,
        iscustomer: false,
        issupplier: false,
        language: 'no',
        state: 2
      },
      fieldsLoading: false,
      loading: false,
      MODULE_URL: 'customers',
      contactDialog: false,
      contactModel: {},
      contactLoading: false,
      listOfContacts: [],
      loadingContacts: false,
      contactActivePage: 1,
      totalContactCount: 0,
      contactLength: 0,
      addressDialog: false,
      addressModel: {},
      listOfAddress: [],
      listOfAddons: [],
      relatedOrderLoading: false,
      listOfRelatedOrders: [],
      addressLoading: false,
      activeOrInactive: 1,
      addonsLoading: false,
      listOfVAT: [{
        text: '0%',
        value: 0
      }, {
        text: '25%',
        value: 25
      }],
      vatLoading: false,
      listOfPaymentType: [
        { id: 1, text: this.$t('message.invoice.saveAndEmail') }
      ],
      modelBack: {},
      isLoading: false,
      search: '',
      isCustomerExists: false,
      companyArray: [],
      items: [],
      exporting: false
    }
  },
  components: {
    'form-data': FormTemplate,
    attachments: () => import('@/components/Attachments'),
    products: () => import('./Details/Products.vue')
  },
  mixins: [Customer],
  computed: {
    ...mapState(['FORM_TYPE', 'listOfCustomerPriorities', 'listofCustomerIndustries', 'listofCustomerShipments', 'listOfProductGroups']),
    customerSupplierSelection () {
      return [val => (!!this.modelObj.issupplier || !!this.modelObj.iscustomer) || 'Required']
    },
    formReferences () {
      return {
        title: this.$route.params.crm_id ? this.$t('message.customer.updateCustomer') : this.$t('message.customer.addCustomer'),
        properties: [{
          type: this.FORM_TYPE.COMBOBOX,
          class: 'lg3 md3 sm9 pa-2',
          iscustomer: true
        }, {
          model: 'vat',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_maxCharValidation(15),
          label: this.$t('message.customer.vat'),
          class: 'lg2 sm3 pa-2',
          disabled: !!this.modelBack.vat,
          change: this.getPaymentMethod
        }, {
          model: 'custom_number',
          type: this.FORM_TYPE.TEXT,
          rules: this.modelObj.custom_number ? this.$_numberValidation : [],
          label: this.$t('message.customer.customerNumber'),
          class: 'lg1 md2 sm3 pa-2',
          disabled: this.modelObj.id && !!this.modelBack.custom_number,
          change: this.changesMade
        }, {
          model: 'email',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_emailValidation,
          label: this.$t('message.customer.email'),
          class: 'lg3 sm6 pa-2',
          change: this.changesMade
        }, {
          model: 'invoiceemail',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_emailValidation,
          label: this.$t('message.customer.invoiceEmail'),
          class: 'lg3 sm6 pa-2',
          change: this.changesMade
        }, {
          model: 'homepage',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: this.$t('message.customer.homepage'),
          class: 'lg3 sm6 pa-2',
          append_icon: 'mdi-link-variant',
          append_click: this.navigateToPage,
          change: this.changesMade
        }, {
          model: 'language',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          label: this.$t('message.login.language'),
          items: this.$_languagesList,
          select_text: 'title',
          select_value: 'value',
          class: 'lg1 md2 sm6 pa-2',
          change: this.changesMade
        }, {
          model: 'location',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          label: this.$t('message.deviations.location'),
          items: this.$_locations,
          select_text: 'text',
          select_value: 'value',
          class: 'lg1 md2 sm6 pa-2',
          change: this.changesMade
        }, {
          model: 'priority',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listOfCustomerPriorities,
          term: 'priority',
          select_text: 'name',
          select_value: 'id',
          class: 'lg2 sm6 pa-2',
          label: this.$t('message.stocks.category'),
          change: this.changesMade
        }, {
          model: 'vatid',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          label: `${this.$t('message.customer.vatValue')} %`,
          items: this.listOfVAT,
          select_text: 'text',
          select_value: 'value',
          class: 'lg1 sm6 pa-2',
          change: this.changesMade
        }, {
          model: 'industry',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listofCustomerIndustries,
          term: 'industry',
          click: (term) => this.supportingList(this.CUSTOMER_INDUSTRY, term),
          is_list: true,
          select_text: 'name',
          select_value: 'id',
          class: 'lg2 sm6 pa-2',
          label: this.$t('message.customer.industry'),
          change: this.changesMade
        }, {
          model: 'shipment',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          items: this.listofCustomerShipments,
          term: 'shipment',
          click: (term) => this.supportingList(this.CUSTOMER_SHIPMENT, term),
          is_list: true,
          select_text: 'name',
          select_value: 'id',
          class: 'lg2 sm6 pa-2',
          label: this.$t('message.customer.shipment'),
          change: this.changesMade
        }, {
          model: 'state',
          type: this.FORM_TYPE.SELECT,
          rules: [],
          label: this.$t('message.customer.state'),
          items: this.$_listOfCustomerStates,
          select_text: 'name',
          select_value: 'id',
          class: 'lg2 sm6 pa-2',
          change: this.changesMade
        }, {
        //   model: 'paymentmethod1',
        //   type: this.FORM_TYPE.SELECT,
        //   rules: [],
        //   label: `${this.$t('message.customer.paymentmethod')} 1`,
        //   items: this.paymentMethod1,
        //   select_text: 'text',
        //   select_value: 'id',
        //   class: 'lg2 sm6 pa-2',
        //   change: this.changesMade
        // }, {
          model: 'paymentmethod2',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: [],
          label: `${this.$t('message.customer.paymentmethod')}`, // removed 2
          items: this.listOfPaymentType,
          loading: this.vatLoading,
          select_text: 'text',
          select_value: 'id',
          class: 'lg2 md3 sm6 pa-2',
          change: this.changesMade
        }, {
          model: 'paymentterm',
          type: this.FORM_TYPE.TEXT,
          rules: [],
          label: `${this.$t('message.order.paymentTerm')}`,
          class: 'lg2 md3 sm6 pa-2',
          suffix: this.$t('message.common.days'),
          change: this.changesMade
        }, {

          model: 'iscustomer',
          rules: this.customerSupplierSelection,
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg1 md2 sm4 pa-2',
          label: this.$t('message.customer.iscustomer'),
          change: this.changesMade
        }, {
          model: 'issupplier',
          rules: this.customerSupplierSelection,
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg2 md2 sm4 pa-2',
          label: this.$t('message.customer.issupplier'),
          change: this.changesMade
        }, {
          model: 'isactive',
          rules: [],
          type: this.FORM_TYPE.CHECKBOX,
          class: 'lg1 md2 sm4 pa-2',
          label: this.$t('message.common.isActive'),
          change: this.changesMade
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.$route.params.crm_id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: () => this.saveUpdateHandler(this.SAVE),
          loading: this.loading,
          is_show: true
        }, {
          name: 'close_handler',
          color: 'primary',
          label: this.$t('message.common.updateAndClose'),
          click: () => this.saveUpdateHandler(this.UPDATE_CLOSE),
          loading: this.loading,
          is_show: this.$route.params.crm_id
        }, {
          name: 'back_to_list',
          color: 'info',
          // eslint-disable-next-line
          click: () => this.$router.push(`/${this.MODULE_URL}`),
          label: this.$t('message.common.backToList'),
          to: `/${this.MODULE_URL}`,
          is_show: true
        }, {
          name: 'delete_btn',
          color: 'error',
          label: this.$t('message.common.delete'),
          click: this.deleteHandler,
          is_show: this.$route.params.crm_id
        }]
      }
    },
    addressHeaders () {
      return [{
        text: this.$t('message.customer.address'),
        value: 'address'
      }, {
        text: this.$t('message.customer.country'),
        value: 'countryname'
      }, {
        text: `${this.$t('message.customer.addressType')}`,
        value: 'type'
      // }, {
      //   text: this.$t('message.customer.coordinates'),
      //   value: 'coordinates'
      }, {
        text: this.$t('message.customer.isStandard'),
        value: 'isstandard',
        isBoolean: true,
        sortable: false
      }]
    },
    paymentMethod1 () {
      return [
        { text: this.$t('message.customer.sg'), value: 'sg' },
        { text: this.$t('message.customer.direct'), value: 'direct' }
      ]
    },
    activeTypes () {
      return [
        { text: this.$t('message.tickets.all'), id: 1 },
        { text: this.$t('message.customer.active'), id: 2 },
        { text: this.$t('message.customer.Inactive'), id: 3 }
      ]
    }
  },
  mounted () {
    if (this.modelObj.id) {
      this.getSingleRecordHandler()
      this.getAllContactsHandler()
      this.getAllAddressHandler()
      this.getRelatedOrdersByCustomer()
    } else {
      this.modelObj.location = 'norwegian'
      this.modelObj.paymentterm = 30
      this.modelObj.vatid = 25
    }
    this.$store.dispatch('getCustomerPriority')
      .then((response) => {
        if (!this.modelObj.id) {
          this.setDefaultValues({ prop: 'priority', list: this.listOfCustomerPriorities })
        }
      })
    this.$store.dispatch('getCustomerIndustry')
      .then((response) => {
        if (!this.modelObj.id) {
          this.setDefaultValues({ prop: 'industry', list: this.listofCustomerIndustries })
        }
      })
    this.$store.dispatch('getCustomerShipment')
      .then((response) => {
        if (!this.modelObj.id) {
          this.setDefaultValues({ prop: 'shipment', list: this.listofCustomerShipments })
        }
      })
    if (this.modelObj.id) {
      this.$store.dispatch('getProductGroups')
        .then((response) => {
          const addons = [...this.listOfProductGroups]
          const addonsList = []
          for (let i = 0; i < addons.length; i++) {
            addonsList.push({
              productgroupid: addons[i].id,
              name: addons[i].name,
              supplierid: this.modelObj.id,
              shipment: '0',
              other: '0'
            })
          }
          this.getAllAddonsHandler(addonsList)
        })
    }

    const text = this.$t('message.common.deleteSuccess')
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE_URL) {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.$router.push(`/${this.MODULE_URL}`)
      } else if (data === 'contacts') {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getAllContactsHandler()
      } else if (data === 'customeraddresses') {
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getAllAddressHandler()
      }
    })
  },
  watch: {
    'modelObj.name': function (val) {
      if (val !== undefined) {
        this.autoFillAddress(val)
      }
    },
    activeOrInactive () {
      this.contactActivePage = 1
      this.getAllContactsHandler()
    },
    contactActivePage (val, oldVal) {
      if (val !== oldVal) this.getAllContactsHandler()
    },
    'search' (val) {
      if (val === null || val.length <= 1) {
        const model = Object.assign({ ...this.modelObj }, { city: '', address: '', post: '' })
        this.modelObj = model
        this.companyArray = []
      } else {
        this.isLoading = true
        this.loadCompanyData()
      }
    }
  },
  methods: {
    getPaymentMethod () {
      this.verfifyVat()
      this.changesMade()
    },
    verfifyVat () {
      if (this.modelObj.vat) {
        this.vatLoading = true
        this.$_executeApi('get', `https://hotell.difi.no/api/json/difi/elma/participants?PEPPOLBIS_3_0_BILLING_01_UBL=Ja&query=${this.modelObj.vat}`, { headers: '' })
          .then(response => {
            if (response) {
              if (response.data.entries.length > 0) {
                this.listOfPaymentType.push({ id: 2, text: this.$t('message.invoice.saveAndUseEHF') })
              } else {
                var removeIndex = this.listOfPaymentType.findIndex(x => x.id === 2)
                if (removeIndex && removeIndex !== -1) this.listOfPaymentType.splice(removeIndex, 1)
              }
            }
          })
          .finally(() => {
            this.vatLoading = false
          })
      }
    },
    // Search from company API
    loadCompanyData () {
      this.$_executeApi('get', 'https://data.brreg.no/enhetsregisteret/api/enheter?navn=' + encodeURIComponent(this.search), { headers: '' }).then(response => {
        this.items = response.data && response.data._embedded ? response.data._embedded.enheter : ''
        this.companyArray = []
        if (this.items) {
          for (let i = 0; i < this.items.length; i++) {
            this.companyArray.push(this.items[i].navn)
          }
        }
      }).finally(() => {
        this.isLoading = false
      })
    },
    // Fill Fields from comapny API
    autoFillAddress (name) {
      if (this.companyArray.length > 0 && this.items) {
        for (var i = 0; i < this.items.length; i++) {
          if (this.items[i].navn === name && this.items[i].forretningsadresse) {
            this.modelObj.vat = this.items[i].organisasjonsnummer
          }
        }
        if (this.modelObj.vat) this.verfifyVat()
        this.checkIfOrgNumberExists()
      }
    },
    checkIfOrgNumberExists () {
      this.changesMade()
      this.isCustomerExists = false
      if (this.modelObj.vat) {
        const query = { filter: `vat eq '${this.modelObj.vat}'` }
        this.$_executeApi('post', 'customers/query', query)
          .then(response => {
            const getCustomers = response.data
            this.isCustomerExists = getCustomers.length > 0
          })
      }
    },
    setDefaultValues (data) {
      const { list, prop } = data
      const item = list.find(x => x.isdefault)
      if (item) {
        const model = Object.assign({ ...this.modelObj }, { [prop]: item.id })
        this.modelObj = model
      }
    },
    getSingleRecordHandler () {
      this.fieldsLoading = true
      this.$_getSingleRecordHandler(`${this.MODULE_URL}/${this.modelObj.id}`)
        .then((result) => {
          if (result.data) {
            this.modelObj = result.data
            if (result.data) {
              const payload = result.data
              payload.paymentmethod2 = +payload.paymentmethod2
              this.modelObj = payload
              this.modelBack = this.$formatter.cloneVariable(payload)
              if (this.modelObj.vat) this.verfifyVat()
            }
          }
        })
        .finally(() => {
          this.fieldsLoading = false
        })
    },
    saveUpdateHandler (type) {
      if (this.$refs.crmReference.$refs.validateForm.validate()) {
        this.loading = true
        const model = this.modelObj
        const url = this.MODULE_URL
        this.$_saveUpdateHandler(url, model)
          .then((response) => {
            this.$store.commit('isChangesMade', false)
            if (model.id && model.issupplier) {
              this.saveAddonValues()
                .then(() => {
                  if (type === this.SAVE && !model.id) this.$router.push(`/${this.MODULE_URL}/actions/${response.id}`)
                  else if (type === this.UPDATE_CLOSE) this.$router.push(`/${this.MODULE_URL}`)
                })
            } else {
              if (type === this.SAVE && !model.id) this.$router.push(`/${this.MODULE_URL}/actions/${response.id}`)
              else if (type === this.UPDATE_CLOSE) this.$router.push(`/${this.MODULE_URL}`)
            }
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    deleteHandler () {
      const ids = [this.modelObj.id]
      const payload = { ids, url: `${this.MODULE_URL}/delete_multiple`, module: this.MODULE_URL }
      this.$store.commit('showDeleteDialog', payload)
    },
    getRelatedOrdersByCustomer () {
      this.relatedOrderLoading = true
      const query = {
        expand: [{
          Model: 'User',
          on_field: 'id',
          on_parent_field: 'responsible',
          select: ['name']
        }],
        filter: `customerid eq ${this.modelObj.id}`
      }
      this.$_executeApi('post', 'orders/query', query)
        .then((response) => {
          const results = response.data
          const transformData = { date: { list: ['orderdate', 'deliverydate'], from: 'DD.MM.YYYY', to: 'DD.MM.YYYY' } }
          const model = this.$_formatListModel(results, transformData)
          model.map(x => {
            x.status = x.state
            const getStatusName = this.getStatusName(x.state)
            x.state = getStatusName ? getStatusName.name : x.state
            return x
          })
          this.listOfRelatedOrders = model
        })
        .finally(() => {
          this.relatedOrderLoading = false
        })
    },
    getStatusName (state) {
      return this.$_findValueInArray(this.$_salesOrderStatus, x => x.id === state)
    },
    addNewContact () {
      this.contactDialog = true
      this.contactModel = { isactive: true }
    },
    closeAddNewContact () {
      this.contactDialog = false
      this.contactModel.id = undefined
      this.$refs.contactReference.$refs.validateForm.reset()
    },
    getAllContactsHandler () {
      this.loadingContacts = true
      const pageVal = this.contactActivePage || 1
      const query = {
        filter: `customer_id eq ${this.modelObj.id}`,
        skip: ((pageVal - 1) * 8),
        limit: 8,
        include_count: true,
        order_by: {
          field: 'firstname',
          asc_or_desc: 'asc'
        }
      }
      if (this.activeOrInactive === 2) query.additionalfilters = ['isactive eq \'1\'']
      else if (this.activeOrInactive === 3) query.additionalfilters = ['isactive eq \'0\'']
      this.$_executeApi('post', 'contacts/query', query)
        .then((response) => {
          const { values, count } = response.data
          this.totalContactCount = count
          this.contactLength = Math.ceil(count / 8)
          this.listOfContacts = values
        })
        .finally(() => {
          this.loadingContacts = false
        })
    },
    editContactHandler (id) {
      this.$_executeApi('get', `contacts/${id}`)
        .then((response) => {
          this.contactModel = response.data
          this.contactDialog = true
        })
    },
    saveUpdateContactHandler () {
      if (this.$refs.contactReference.$refs.validateForm.validate()) {
        this.contactLoading = true
        const model = this.$formatter.cloneVariable(this.contactModel)
        model.customer_id = this.modelObj.id
        this.$_saveUpdateHandler('contacts', model)
          .then((response) => {
            this.closeAddNewContact()
            this.getAllContactsHandler()
          })
          .finally(() => {
            this.contactLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    deleteContactHandler (id) {
      const ids = [id]
      const payload = { ids, url: 'contacts/delete_multiple', module: 'contacts' }
      this.$store.commit('showDeleteDialog', payload)
    },
    addNewAddress () {
      this.addressDialog = true
      this.addressModel = { isstandard: true }
    },
    closeAddNewAddress () {
      this.addressDialog = false
      this.addressLoading = false
      this.addressModel.id = undefined
      this.$refs.addressReference.$refs.validateForm.reset()
    },
    getAllAddressHandler () {
      const query = { filter: `customer_id eq ${this.modelObj.id}` }
      this.$_executeApi('post', 'customeraddresses/query', query)
        .then((response) => {
          this.listOfAddress = response.data
        })
    },
    editAddressHandler (id) {
      this.$_executeApi('get', `customeraddresses/${id}`)
        .then((response) => {
          const model = response.data
          model.type = model.type ? JSON.parse(model.type) : []
          this.addressModel = model
          this.addressDialog = true
        })
    },
    saveUpdateAddressHandler () {
      if (this.$refs.addressReference.$refs.validateForm.validate()) {
        this.addressLoading = true
        const model = this.addressModel
        model.customer_id = this.modelObj.id
        model.type = model.type ? typeof model.type !== 'string' ? JSON.stringify(model.type) : model.type : ''
        this.$_saveUpdateHandler('customeraddresses', model)
          .then((response) => {
            this.closeAddNewAddress()
            this.getAllAddressHandler()
          })
          .finally(() => {
            this.addressLoading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    },
    getAllAddonsHandler (addons) {
      const query = {
        expand: [{
          Model: 'ProductGroup',
          on_field: 'id',
          on_parent_field: 'ProductGroupId',
          select: ['Name']
        }],
        filter: `supplierid eq ${this.modelObj.id}`
      }
      this.$_executeApi('post', 'transportationcosts/query', query)
        .then((response) => {
          const model = response.data
          const transformData = { number: { list: ['shipment', 'other'], format: 'replaceDotWithComma' } }
          const addedList = this.$_formatListModel(model, transformData)
          const resultAddons = []
          if (addons && addons.length > 0) {
            for (let i = 0; i < addons.length; i++) {
              const hasIndex = addedList.findIndex(x => x.productgroupid === addons[i].productgroupid)
              if (hasIndex > -1) {
                resultAddons.push(Object.assign({ ...addedList[hasIndex] }, { name: addons[i].name }))
              } else {
                const item = {
                  productgroupid: addons[i].productgroupid,
                  name: addons[i].name,
                  supplierid: this.modelObj.id,
                  shipment: '0',
                  other: '0'
                }
                resultAddons.push(item)
              }
            }
          }
          this.listOfAddons = resultAddons
        })
    },
    saveAddonValues () {
      return new Promise((resolve, reject) => {
        if (this.$refs.addonsForm) {
          if (this.$refs.addonsForm.validate()) {
            this.addonsLoading = true
            const transformData = { number: { list: ['shipment', 'other'], format: 'replaceCommaWithDot' } }
            const model = this.$_formatListModel(this.listOfAddons, transformData)
            this.$_executeApi('post', 'transportationcosts/bulk_save', model)
              .then((response) => {
                this.addonsLoading = false
                resolve()
              })
              .catch((err) => {
                reject(err)
              })
          } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
        } else resolve()
      })
    },
    navigateToPage () {
      if (this.modelObj.homepage) {
        if (this.isValidHttpUrl(this.modelObj.homepage)) {
          window.open(`${this.modelObj.homepage}`, '_blank')
        } else window.open(`https://${this.modelObj.homepage}`, '_blank')
      }
    },
    isValidHttpUrl (string) {
      let url
      try {
        url = new URL(string)
      } catch (_) {
        return false
      }
      return url.protocol === 'http:' || url.protocol === 'https:'
    },
    deleteAddressHandler (id) {
      const ids = [id]
      const payload = { ids, url: 'customeraddresses/delete_multiple', module: 'customeraddresses' }
      this.$store.commit('showDeleteDialog', payload)
    },
    setAvatarName (obj) {
      let avatarString = ''
      avatarString += obj.firstname ? this.getFirstLetterUppercase(obj.firstname) : ''
      avatarString += obj.lastname ? this.getFirstLetterUppercase(obj.lastname) : avatarString
      return avatarString
    },
    getFirstLetterUppercase (text) {
      return text ? text.charAt(0).toUpperCase() : ''
    },
    // getCoordinates (obj) {
    //   const coordinates = (({ latitude, longitude }) => ({ latitude, longitude }))(obj)
    //   return this.getCommaStringFromObj(coordinates)
    // },
    getCombinedAddress (obj) {
      const addressItems = (({ address, address2, postcode, city }) => ({ address, address2, postcode, city }))(obj)
      return this.getCommaStringFromObj(addressItems)
    },
    getCommaStringFromObj (obj) {
      Object.keys(obj).forEach(key => !obj[key] && delete obj[key])
      return Object.values(obj).join(', ')
    },
    getaddressType (type) {
      if (type) {
        const getTypes = JSON.parse(type)
        const translatedTypes = []
        if (getTypes) {
          getTypes.map(x => {
            x = this.$t(`message.customer['${x}']`)
            translatedTypes.push(x)
          })
          return translatedTypes.join(', ')
        }
      }
    },
    supportingList (type, text) {
      text = this.$refs.crmReference.$refs[text][0].lazySearch
      const model = { module: type, dialog: true, text }
      this.$store.commit('supportingList', model)
    },
    exportPriceList () {
      this.exporting = true
      this.$_executeApi('post', `products/export_for_customer/${this.modelObj.id}`)
        .then((response) => {
          const fileName = response.data
          this.exporting = false
          window.open(axios.defaults.baseURL + 'file/download/?fileName=' + fileName, '_blank')
        })
    },
    changesMade () {
      this.$store.commit('isChangesMade', true)
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.$store.state.isChangesMade) {
      next()
    } else {
      this.$store.commit('isChangesMade', true)
      this.$store.commit('changeLostDialog', true)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
  }
}
</script>
